import { render, staticRenderFns } from "./ShowRowCol.vue?vue&type=template&id=5657b7a0&scoped=true"
import script from "./ShowRowCol.vue?vue&type=script&lang=js"
export * from "./ShowRowCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5657b7a0",
  null
  
)

export default component.exports